import { useParams, useNavigate } from 'react-router-dom'
import { SubmitHandler } from 'react-hook-form'

import { BarrierForm } from '@containers/Forms/Barrier'
import { TBarrierForm } from '@containers/Forms/Barrier/schema'
import { useAlerts } from '@hooks/alerts'
import { useCreateBarrier } from '@hooks/barriers/create'

export function AddBarrierFormScreen() {
  const { taskId: taskIdParam } = useParams<{ taskId: string }>()
  const taskId = Number(taskIdParam)
  const navigate = useNavigate()

  const { mutateAsync: postBarrier } = useCreateBarrier()
  const { showDismissAlert } = useAlerts()

  const handleSaveBarrier: SubmitHandler<TBarrierForm> = async (
    data: TBarrierForm,
  ) => {
    const { comment, ...rest } = data
    const barrier = {
      ...rest,
      comments: [{ comment: comment || '' }],
    }

    try {
      await postBarrier({ barrier, taskId })
      navigate(-1)
    } catch {
      window.alert('Error\n\nFailed to save barrier. Please try again.')
    }
  }

  function handleShowAlertOnBarrierDismiss() {
    showDismissAlert(() => navigate(-1))
  }

  return (
    <BarrierForm
      onSave={handleSaveBarrier}
      onClose={handleShowAlertOnBarrierDismiss}
    />
  )
}
